<div class="n-list-component-header">
    <h2>List of suppliers</h2>
    <div>
        <!-- <button matIconButton matTooltip="Here comes the info"><mat-icon>info</mat-icon></button> -->
        <button matIconButton matTooltip="Select columns"
            (click)="openColumnSelector()"><mat-icon>view_column</mat-icon></button>
    </div>
</div>

<form [formGroup]="filterForm" class="n-filters-form">
    <div>
        <mat-expansion-panel [(expanded)]="filtersExpanded" #filtersPanel style="margin: 5px 0px; flex-grow: 1; ">
            <mat-expansion-panel-header>
                <mat-panel-title><mat-icon>search</mat-icon> Filters </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="n-filter-form-row" style="align-items: flex-start;">

                <div class="n-select-filter-field-column">
                    <mat-form-field class="n-search-field n-filter-flex-unit.simple" style="width: 100%">
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput placeholder="Name filter" #simpleFilterInput formControlName="textFilter">
                    </mat-form-field>
                    <!-- <app-advanced-select #stakeholderGroupsSelect formControlName="stakeholderGroups"
                        [resetTrigger]="resetCounter" class="n-search-field n-filter-flex-unit"
                        label="Stakeholder groups" [options]="allStakeholderGroupOptions()"
                        [showAllOrAny]="showAllOrAny()" /> -->
                    <app-advanced-select #projectsSelect formControlName="projects" [resetTrigger]="resetCounter"
                        class="n-search-field n-filter-flex-unit" label="Projects" [options]="allProjectOptions()"
                        [showAllOrAny]="showAllOrAny()" />
                </div>

                <div class="n-select-filter-field-column">
                    <app-advanced-select #supplierTypesSelect formControlName="supplierTypes"
                        [resetTrigger]="resetCounter" class="n-search-field n-filter-flex-unit" label="Supplier type"
                        [options]="allSupplierTypeOptions" [showAllOrAny]="showAllOrAny()" />
                    <app-advanced-select #initiativesSelect formControlName="initiatives" [resetTrigger]="resetCounter"
                        class="n-search-field n-filter-flex-unit" label="Initiatives" [options]="allInitiativeOptions()"
                        [showAllOrAny]="showAllOrAny()" />
                </div>

                <div class="n-select-filter-field-column">
                    <app-advanced-select #products formControlName="products" [resetTrigger]="resetCounter"
                        class="n-search-field n-filter-flex-unit" label="Products" [options]="allProductOptions()"
                        [showAllOrAny]="showAllOrAny()" />
                    <app-advanced-select #countrySelect formControlName="countries" [resetTrigger]="resetCounter"
                        class="n-search-field n-filter-flex-unit" label="Countries" [options]="allCountryOptions()"
                        [showAllOrAny]="showAllOrAny()" />
                </div>

                <button matFab (click)="clearAllFilters()" class="n-filter-reset-button"
                    matTooltip="Clear all filters"><mat-icon>clear</mat-icon></button>
            </div>
        </mat-expansion-panel>
    </div>

    <div class="n-table-wrapper">
        @if (loading) {
        <div class="n-spinner-overlay">
            <mat-spinner></mat-spinner>
        </div>
        }

        <div class="n-table-scroll">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

                <!-- name Column -->
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                    <td mat-cell *matCellDef="let organisation"><span class="n-ellipsis">{{ organisation.name }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="member">
                    <th mat-header-cell *matHeaderCellDef matTooltip="Member"><span class="material-symbols-outlined"
                            style="display: inline-block; vertical-align: middle;">family_star</span>
                    </th>
                    <td mat-cell *matCellDef="let organisation">
                        @if (organisation.memberDetails) {
                        <span class="material-symbols-outlined"
                            style="display: inline-block; vertical-align: middle;">family_star</span>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="supplier">
                    <th mat-header-cell *matHeaderCellDef matTooltip="Supplier"><span class="material-symbols-outlined"
                            style="display: inline-block; vertical-align: middle;">partner_exchange</span></th>
                    <td mat-cell *matCellDef="let supplier">
                        @if (supplier.supplierType === SupplierType.CONTACT) {
                        <span class="material-symbols-outlined" matTooltip="Contact"
                            style="display: inline-block; vertical-align: middle;">person</span>
                        } @else if (supplier.supplierType === SupplierType.CONTACT_IN_SUPPLIER_ORG) {
                        <span class="material-symbols-outlined" matTooltip="Contact from organisation {{supplier.affiliatedSuppliers}}"
                            style="display: inline-block; vertical-align: middle;">co_present</span>
                        } @else if (supplier.supplierType === SupplierType.ORGANISATION) {
                        <span class="material-symbols-outlined" matTooltip="Organisation"
                            style="display: inline-block; vertical-align: middle;">corporate_fare</span>
                        } @else {
                        <span class="material-symbols-outlined"
                            style="display: inline-block; vertical-align: middle;">question_mark</span>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="supplierFeedback">
                    <th mat-header-cell *matHeaderCellDef matTooltip="Feedback"><span class="material-symbols-outlined"
                            style="display: inline-block; vertical-align: middle;">favorite</span>
                    </th>
                    <td mat-cell *matCellDef="let supplier">
                        @if (supplier.supplierFeedback === SupplierFeedback.AVOID) {
                        <span class="material-symbols-outlined" matTooltip="Avoid"
                            style="display: inline-block; vertical-align: middle;">thumb_down</span>
                        } @else if (supplier.supplierFeedback === SupplierFeedback.AVERAGE) {
                        <span class="material-symbols-outlined" matTooltip="Average"
                            style="display: inline-block; vertical-align: middle;">thumbs_up_down</span>
                        } @else if (supplier.supplierFeedback === SupplierFeedback.GOOD) {
                        <span class="material-symbols-outlined" matTooltip="Good"
                            style="display: inline-block; vertical-align: middle;">thumb_up</span>
                        } @else if (supplier.supplierFeedback === SupplierFeedback.NOT_YET) {
                        <span class="material-symbols-outlined" matTooltip="Not yet"
                            style="display: inline-block; vertical-align: middle;">check_indeterminate_small</span>
                        } @else {
                        <span class="material-symbols-outlined" matTooltip="N/A"
                            style="display: inline-block; vertical-align: middle;">question_mark</span>
                        }
                    </td>
                </ng-container>


                <ng-container matColumnDef="ongoingRelationship">
                    <th mat-header-cell *matHeaderCellDef matTooltip="Ongoing relationship"><span
                            class="material-symbols-outlined"
                            style="display: inline-block; vertical-align: middle;">handshake</span>
                    </th>
                    <td mat-cell *matCellDef="let supplier">
                        @if (supplier.ongoingRelationship === OngoingRelationship.NOT_YET) {
                        <span class="material-symbols-outlined" matTooltip="Not yet"
                            style="display: inline-block; vertical-align: middle;">check_indeterminate_small</span>
                        } @else if (supplier.ongoingRelationship === OngoingRelationship.QUOTATION_ONLY) {
                        <span class="material-symbols-outlined" matTooltip="Quotation only"
                            style="display: inline-block; vertical-align: middle;">sell</span>
                        } @else if (supplier.ongoingRelationship === OngoingRelationship.YES) {
                        <span class="material-symbols-outlined" matTooltip="Yes"
                            style="display: inline-block; vertical-align: middle;">check_small</span>
                        } @else {
                        <span class="material-symbols-outlined" matTooltip="N/A"
                            style="display: inline-block; vertical-align: middle;">question_mark</span>
                        }
                    </td>
                </ng-container>

                <!-- projects Column -->
                <ng-container matColumnDef="projects">
                    <th mat-header-cell *matHeaderCellDef>Projects</th>
                    <td mat-cell *matCellDef="let supplier">
                        <mat-chip-set class="n-my-chip">
                            @for (project of supplier.projects; track project.id) {
                            <mat-chip><span matTooltip="{{project.name}}">{{ project.name }}</span></mat-chip>
                            }
                        </mat-chip-set>
                    </td>
                </ng-container>

                <!-- initiatives Column -->
                <ng-container matColumnDef="products">
                    <th mat-header-cell *matHeaderCellDef>Products</th>
                    <td mat-cell *matCellDef="let supplier">
                        <mat-chip-set class="n-my-chip">
                            @for (product of supplier.products; track product.id) {
                            <mat-chip><span matTooltip="{{product.name}}">{{ product.name }}</span></mat-chip>
                            }
                        </mat-chip-set>
                    </td>
                </ng-container>

                <!-- initiatives Column -->
                <ng-container matColumnDef="initiatives">
                    <th mat-header-cell *matHeaderCellDef>Initiatives</th>
                    <td mat-cell *matCellDef="let supplier">
                        <mat-chip-set class="n-my-chip">
                            @for (item of supplier.initiatives; track item.id) {
                            <mat-chip><span matTooltip="{{item.name}}">{{ item.name }}</span></mat-chip>
                            }
                        </mat-chip-set>
                    </td>
                </ng-container>

                <ng-container matColumnDef="topics">
                    <th mat-header-cell *matHeaderCellDef>Topics of interest</th>
                    <td mat-cell *matCellDef="let supplier">
                        <mat-chip-set class="n-my-chip">
                            @for (item of supplier.topics; track item.id) {
                            <mat-chip><span matTooltip="{{item.name}}">{{ item.name }}</span></mat-chip>
                            }
                        </mat-chip-set>
                    </td>
                </ng-container>

                <!-- <ng-container matColumnDef="stakeholderGroups">
                    <th mat-header-cell *matHeaderCellDef>Stakeholder groups</th>
                    <td mat-cell *matCellDef="let supplier">
                        <mat-chip-set class="n-my-chip">
                            @for (item of supplier.stakeholderGroups; track item.id) {
                            <mat-chip><span matTooltip="{{item.name}}">{{ item.name }}</span></mat-chip>
                            }
                        </mat-chip-set>
                    </td>
                </ng-container> -->

                <!-- lastModifiedOn Column -->
                <ng-container matColumnDef="lastModifiedOn">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Last modification</th>
                    <td mat-cell *matCellDef="let contact">
                        {{ contact.lastModifiedOn | date:'dd/MM/yyyy HH:mm' }}
                    </td>
                </ng-container>

                <tr mat-header-row class="n-grid-header-row" *matHeaderRowDef="selectedColumns"
                    [ngStyle]="{ 'grid-template-columns': gridTemplate }">
                </tr>
                <tr mat-row class="n-grid-data-row" *matRowDef="let row; columns: selectedColumns"
                    [ngStyle]="{ 'grid-template-columns': gridTemplate }" (click)="goToDetail(row)">
                </tr>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter</td>
                </tr>


            </table>
        </div>
    </div>

    <mat-paginator #paginator class="demo-paginator" showFirstLastButtons="true" hidePageSize="false"
        [pageSizeOptions]="[5,10,25]" aria-label="Select page" />

    <div class="n-button-row">
        <!-- <button matFab extended class="n-export-button" (click)="export()"><mat-icon>file_download</mat-icon>Export
            list</button> -->
    </div>
</form>